import {BydCountry} from "../models/byd-country.model";

const countries = [
    "AL", "BA", "BG", "BH", "BY", "DZ", "EE", "GR", "HR", "IL", "KZ", "LT", "LV", "MO", "QA", "RO", "SCG", "SI", "UA"
];

export const HiltiBydCountryConfig: BydCountry = {
    byDCountries : countries
}
